import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
    setModoTela,
    initForm
} from './veiculoActions';

let VeiculoForm = props => {

    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='placa_nome'
                            component={LabelAndInput}
                            label='Placa / Nome *'
                            placeholder='Informe'
                            cols='12 5 5 5'
                            readOnly={readOnly}
                        />
					</Row>

                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndInput}
                            label='Observação'
                            placeholder='Informe'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='odometro'
                            component={LabelAndCheckbox}
                            label='Odômetro'
                            placeholder='Informe'
                            cols='12 1 1 1'
							minWidth={150}
                            readOnly={readOnly}
                        />

                        <Field
                            name='horimetro'
                            component={LabelAndCheckbox}
                            label='Horímetro'
                            placeholder='Informe'
                            cols='12 1 1 1'
							minWidth={150}
                            readOnly={readOnly}
                        />
                    </Row>

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

VeiculoForm = reduxForm({
    form: 'veiculoForm',
    destroyOnUnmount: false
})(VeiculoForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    formularioValues: getFormValues('veiculoForm')(state),
    registro: state.veiculo.registro
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VeiculoForm);